<template>
    <div class="progress-items">
        <el-row class="flex-row">
            <!-- 每个卡片col添加box-sizing确保padding不影响宽度 -->
            <el-col :span="6" class="progress-items-card" v-for="(delivery, index) in deliveryList"
                :key="delivery.title">
                <div class="progress-items-title">
                    <div class="card-title-indicator"></div>
                    <div>{{ delivery.title }}</div>
                </div>
                <div class="flex-row item-mian">
                    <div class="item-left">
                        <el-image class="icon-data" :src="require(`../images/icon-data-${index}.png`)" fit="scale-down"></el-image>
                    </div>
                    <div class="item-right">
                        <div class="progress-items-item" v-for="cell in delivery.data" :key="cell.name">
                            <div class="item-main">
                                <div class="progress-txt">
                                    <div>{{ cell.name }}</div>
                                    <div class="progress-txt-num">{{ cell.value }} {{ cell.unit }}</div>
                                </div>
                                <el-progress
                                    class="progress-data c-mainpage-right__progress el-progress--main-right-style el-progress--main-right-color2"
                                    :stroke-width="14" :show-text="false" stroke-linecap="round"
                                    :percentage="getPercentage(delivery.data, cell.name)"
                                    :format="progressTxt"></el-progress>
                            </div>
                        </div>
                    </div>

                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>

export default {
    name: 'progressChart',
    props: {
        deliveryList: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    watch: {
        deliveryList: {
            handler (newVal) {
                console.log('deliveryList', newVal);
            },
            immediate: true,
        },
    },
    data () {
        return {
        };
    },
    methods: {
        getPercentage (dataList, type) {
            const totalItem = dataList[1].value; // 假定总数是第二个项目的值
            const dayItem = dataList[0].value; // 假定总数是第二个项目的值

            let num = 0;
            if (type === '日均') {
                num = dayItem > 0 ? dayItem / totalItem * 100 : 0;
            } else {
                num = totalItem > 0 ? 100 : 0;
            }
            return num;
        },
        // 进度条显示文本（可选：区分日均和总数）
        progressTxt () {
            return '';
        },
    },
};
</script>
<style lang="scss" scoped>
// 引入全局变量
$borderColor: #1a47a4;
$highlightColor: #34C6D0;
$cardColor0: #3D8AE5;
$bgColor: #071150;

// 全局盒模型设置（确保padding不影响宽度计算）
* {
    box-sizing: border-box;
}

.progress-items {
    width: 100%;
    background-color: $bgColor;

    .flex-row {
        display: flex;
        width: 100%; // 确保row占满父容器
        flex-wrap: wrap; // 可选：当卡片过多时自动换行
    }

    .progress-items-card {
        margin-right: 16px;
        border-radius: 4px;
        width: 100%; // 关键：让卡片占满el-col的宽度
        max-width: calc(25% - 16px); // 配合span=6（25%宽度），减去margin避免溢出

        &:last-child {
            margin-right: 0;
        }

        .progress-items-title {
            line-height: 28px;
            height: 30px;
            font-size: 16px;
            margin-bottom: 10px;
            display: flex;

            .card-title-indicator {
                width: 4px;
                height: 18px;
                background-color: $cardColor0;
                margin: 6px 5px 0 0;
            }
        }

        .item-mian {
            padding: 10px;
            .item-left {
                display: flex;
                align-items: center;
                .icon-data {
                    margin-top: 10px;
                    width: 121px;
                    height: 85px;

                }
            }

            .item-right {
                width: calc(100% - 121px);
                .progress-items-item {
                    // 移除不必要的红色边框（避免影响宽度）
                    // border: 1px red solid;
                    width: 100%; // 确保每个进度项占满卡片宽度

                    .progress-txt {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 30px;
                    }

                    // 关键：控制el-progress的宽度
                    .el-progress {
                        width: 100% !important; // 强制进度条占满父容器
                        max-width: 100%; // 限制最大宽度为父容器宽度
                    }
                }
            }
        }

    }

}

// 穿透 scoped 限制，修改进度条样式
::v-deep.progress-data .el-progress-bar__outer {
    background-color: #ffffff80 !important;
    border-radius: 0 !important;

}

::v-deep.el-progress--main-right-style .el-progress-bar__inner::after {
    display: none;
}
</style>
